import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class AllDataPaginatorIntl extends MatPaginatorIntl {
  override readonly itemsPerPageLabel = 'Citations per page:';
}
